import store from "../../../store";
import user_settings from "./user_settings";

window.USR_APP =  new Vue({
	store,
	name : "USER_CABINET",
	el: '#user_profile',

	data () {
		return {
			showModal: false,
		}
	},
	created () {

	},

	components : {
		user_settings
	}
});
